'use client';

import { c as _c } from "react/compiler-runtime";
import { useMediaState } from '@7f-ui/hooks/use-media-state';
import type { NexperienceSearchItemFragment } from '@data-access/lib/gql/experience/documents';
import { isAppEnv } from '@utils/utils-config';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import type { PartnerMapMarker } from './partner-map';
const PartnerMap = dynamic(() => import('./partner-map').then(m => m.PartnerMap), {
  ssr: false
});
type PartnerLocationsProps = {
  merchantPublicId: number;
  experiences: NexperienceSearchItemFragment[];
};
export function PartnerLocations(t0) {
  const $ = _c(12);
  const {
    merchantPublicId,
    experiences
  } = t0;
  const isMobile = useMediaState("mobile");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isAppEnv("e2e");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const skipLiveMap = t1;
  const [mapMounted, setMapMounted] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      rootMargin: "100px",
      freezeOnceVisible: true,
      onChange: isIntersecting => {
        if (isIntersecting) {
          setMapMounted(true);
        }
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    ref
  } = useIntersectionObserver(t2);
  let t3;
  if ($[2] !== experiences) {
    t3 = experiences.map(_temp);
    $[2] = experiences;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const markers = t3;
  if (markers.length === 0) {
    return null;
  }
  let t4;
  if ($[4] !== isMobile || $[5] !== mapMounted || $[6] !== markers || $[7] !== merchantPublicId) {
    t4 = mapMounted && !skipLiveMap ? <PartnerMap isMobile={isMobile} markers={markers} merchantPublicId={merchantPublicId} /> : <div className="size-full bg-sand" />;
    $[4] = isMobile;
    $[5] = mapMounted;
    $[6] = markers;
    $[7] = merchantPublicId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== ref || $[10] !== t4) {
    t5 = <div ref={ref} className="aspect-4/3 overflow-hidden rounded-xl sm:aspect-video">{t4}</div>;
    $[9] = ref;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(t0) {
  const {
    publicId,
    slug,
    lat,
    lng
  } = t0;
  return {
    publicId,
    slug,
    lat,
    lng
  };
}